import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import en from "./locales/en.json";
import hi from "./locales/hi.json";

const resources = {
  en: { translation: en },
  hi: { translation: hi },
};

const languageDetectorOptions = {
  order: ["navigator", "sessionStorage"], 
  caches: ["sessionStorage"], 
};


i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind react-i18next to the app
  .init({
      resources,
      // debug:true,
    fallbackLng: "en", 
    detection:languageDetectorOptions,
    interpolation: {
      escapeValue: false, 
    },
  
  });

export default i18n;
 